import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

export default function SEO({ lang, title, description }) {
  const { image } = useStaticQuery(
    graphql`
        query {
            image: file(sourceInstanceName: { eq: "images" }, name:{ eq: "definition"} ) {
                id
                name
                childImageSharp {
                    fixed(
                        height: 200
                    ) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
        }
    `,
  );
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | Malingering`}
      // meta={[
      //   {
      //     name: `description`, content: description,
      //   },
      //   {
      //     property: `og:title`, content: title,
      //   },
      //   {
      //     property: `og:description`, content: description,
      //   },
      //   {
      //     property: `og:type`, content: `website`,
      //   },
      //   {
      //     property: 'og:image', content: image.childImageSharp.fixed.src,
      //   },
      //   {
      //     property: 'og:image:width', content: image.childImageSharp.fixed.width,
      //   },
      //   {
      //     property: 'og:image:height', content: image.childImageSharp.fixed.height,
      //   },
      //   {
      //     name: 'twitter:card', content: 'summary_large_image',
      //   },
      //   {
      //     name: `twitter:creator`, content: 'University of Turin',
      //   },
      //   {
      //     name: `twitter:title`, content: title,
      //   },
      //   {
      //     name: `twitter:description`, content: description,
      //   },
      //   {
      //     name: `twitter:image`, content: image.childImageSharp.fixed.src,
      //   },
      // ]}
    />
  );
}

SEO.defaultProps = {
  lang: `it`,
  description: ``,
};

SEO.propTypes =
  {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    lang: PropTypes.string,
  }
;
